import { useAuthGate, AuthModal } from './AuthGate';
import React, { useState, useEffect, useCallback } from 'react';

const API = '';
const getHeaders = () => ({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token') || localStorage.getItem('nomokratia_token')}` });

const Badge = ({ level, small }) => {
  const c = { HIGH: {bg:'#FEE2E2',color:'#991B1B',t:'🔴 Σύγκρουση'}, MEDIUM: {bg:'#FEF3C7',color:'#92400E',t:'🟡 Πιθανή'}, LOW: {bg:'#DBEAFE',color:'#1E40AF',t:'🔵 Χαμηλή'}, CLEAR: {bg:'#D1FAE5',color:'#065F46',t:'🟢 Καθαρό'} }[level] || {bg:'#D1FAE5',color:'#065F46',t:'🟢 Καθαρό'};
  return <span style={{display:'inline-flex',alignItems:'center',gap:4,padding:small?'2px 8px':'4px 12px',borderRadius:999,fontSize:small?11:13,fontWeight:600,background:c.bg,color:c.color}}>{c.t}</span>;
};

const ConflictCheck = () => {
  const [name, setName] = useState('');
  const [vat, setVat] = useState('');
  const [role, setRole] = useState('client');
  const [desc, setDesc] = useState('');
  const [related, setRelated] = useState('');
  const [area, setArea] = useState('');
  const [activeOnly, setActiveOnly] = useState(false);
  const [useAI, setUseAI] = useState(true);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const { showModal, setShowModal, guardedAction, onSuccess } = useAuthGate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setLoading(true); setError(null); setResult(null);
    try {
      const res = await fetch(`${API}/api/crm/conflicts/check`, {
        method: 'POST', headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
          name, vat_number: vat || null, role, case_description: desc || null,
          legal_area: area || null,
          related_names: related ? related.split(',').map(n=>n.trim()).filter(Boolean) : [],
          check_active_only: activeOnly, include_ai_analysis: useAI
        })
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setResult(await res.json());
    } catch(err) { setError(err.message); }
    setLoading(false);
  };

  const inp = {width:'100%',padding:'10px 14px',borderRadius:10,border:'1px solid #E2E8F0',fontSize:14,outline:'none'};
  const lbl = {display:'block',fontSize:13,fontWeight:600,color:'#374151',marginBottom:4};

  return (
    <div style={{maxWidth:900,margin:'0 auto',padding:24}}>
      <div style={{marginBottom:24}}>
        <h2 style={{fontSize:22,fontWeight:700,color:'#1E293B',display:'flex',alignItems:'center',gap:10}}>
          <span style={{fontSize:28}}>⚖️</span> Έλεγχος Σύγκρουσης Συμφερόντων
        </h2>
        <p style={{fontSize:14,color:'#64748B',marginTop:4}}>
          Ελέγξτε αν η ανάληψη νέου εντολέα δημιουργεί σύγκρουση
          <span style={{fontSize:12,color:'#94A3B8',marginLeft:8}}>(Ν. 4194/2013, άρθρα 35-37)</span>
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        <div style={{background:'#FFF',borderRadius:16,border:'1px solid #E2E8F0',padding:24,boxShadow:'0 2px 8px rgba(0,0,0,0.04)'}}>
          <div style={{display:'grid',gridTemplateColumns:'2fr 1fr',gap:16,marginBottom:16}}>
            <div>
              <label style={lbl}>👤 Όνομα / Επωνυμία *</label>
              <input type="text" placeholder="π.χ. Παπαδόπουλος Ιωάννης" value={name} onChange={e=>setName(e.target.value)} style={inp} required />
            </div>
            <div>
              <label style={lbl}># ΑΦΜ</label>
              <input type="text" placeholder="123456789" maxLength={9} value={vat} onChange={e=>setVat(e.target.value)} style={inp} />
            </div>
          </div>

          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:16}}>
            <div>
              <label style={lbl}>📋 Ρόλος</label>
              <select value={role} onChange={e=>setRole(e.target.value)} style={{...inp,cursor:'pointer'}}>
                <option value="client">Πελάτης</option>
                <option value="opposing_party">Αντίδικος</option>
                <option value="witness">Μάρτυρας</option>
                <option value="related">Συσχετιζόμενο πρόσωπο</option>
              </select>
            </div>
            <div>
              <label style={lbl}>⚖️ Τομέας Δικαίου</label>
              <select value={area} onChange={e=>setArea(e.target.value)} style={{...inp,cursor:'pointer'}}>
                <option value="">-- Επιλέξτε --</option>
                <option value="civil">Αστικό</option>
                <option value="criminal">Ποινικό</option>
                <option value="administrative">Διοικητικό</option>
                <option value="commercial">Εμπορικό</option>
                <option value="labor">Εργατικό</option>
                <option value="family">Οικογενειακό</option>
                <option value="tax">Φορολογικό</option>
              </select>
            </div>
          </div>

          <div style={{marginBottom:16}}>
            <label style={lbl}>📝 Περιγραφή Υπόθεσης</label>
            <textarea placeholder="Σύντομη περιγραφή..." value={desc} onChange={e=>setDesc(e.target.value)} style={{...inp,minHeight:60,resize:'vertical'}} />
          </div>

          <div style={{marginBottom:16}}>
            <label style={lbl}>👥 Συσχετιζόμενα πρόσωπα (με κόμμα)</label>
            <input type="text" placeholder="π.χ. Παπαδοπούλου Μαρία, BETA O.E." value={related} onChange={e=>setRelated(e.target.value)} style={inp} />
          </div>

          <div style={{display:'flex',gap:24,marginBottom:20}}>
            <label style={{display:'flex',alignItems:'center',gap:8,fontSize:13,color:'#475569',cursor:'pointer'}}>
              <input type="checkbox" checked={activeOnly} onChange={e=>setActiveOnly(e.target.checked)} /> Μόνο ενεργές υποθέσεις
            </label>
            <label style={{display:'flex',alignItems:'center',gap:8,fontSize:13,color:'#475569',cursor:'pointer'}}>
              <input type="checkbox" checked={useAI} onChange={e=>setUseAI(e.target.checked)} /> 🤖 AI Νομική Ανάλυση
            </label>
          </div>

          <button type="submit" disabled={loading||!name.trim()} style={{
            width:'100%',padding:'14px',borderRadius:12,background:loading?'#94A3B8':'#1E293B',
            color:'#FFF',fontSize:15,fontWeight:700,border:'none',cursor:loading?'wait':'pointer'
          }}>
            {loading ? '⏳ Έλεγχος σε εξέλιξη...' : '⚖️ Εκτέλεση Ελέγχου'}
          </button>
        </div>
      </form>

      <AuthModal show={showModal} onClose={()=>setShowModal(false)} onSuccess={onSuccess} />
      {error && <div style={{marginTop:16,padding:16,borderRadius:12,background:'#FEF2F2',border:'1px solid #FECACA',color:'#991B1B',fontSize:14}}>❌ {error}</div>}

      {result && (
        <div style={{marginTop:24}}>
          <div style={{borderRadius:16,padding:20,marginBottom:16,background:result.risk_level==='HIGH'?'#FEF2F2':result.risk_level==='MEDIUM'?'#FFFBEB':result.risk_level==='CLEAR'?'#F0FDF4':'#EFF6FF',border:'1px solid '+(result.risk_level==='HIGH'?'#FECACA':result.risk_level==='MEDIUM'?'#FDE68A':'#A7F3D0')}}>
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
              <div style={{display:'flex',alignItems:'center',gap:12}}>
                <span style={{fontSize:32}}>{result.risk_level==='HIGH'?'🚨':result.risk_level==='MEDIUM'?'⚠️':'✅'}</span>
                <div>
                  <div style={{fontSize:18,fontWeight:700}}>{result.risk_level==='HIGH'?'Σύγκρουση Συμφερόντων!':result.risk_level==='MEDIUM'?'Πιθανή Σύγκρουση':'Κανένα Πρόβλημα'}</div>
                  <div style={{fontSize:13,color:'#64748B'}}>{result.total_matches} αντιστοιχίες σε {result.checked_against} εγγραφές ({result.check_duration_ms}ms)</div>
                </div>
              </div>
              <Badge level={result.risk_level} />
            </div>
          </div>

          {result.matches.length > 0 && (
            <div style={{background:'#FFF',borderRadius:16,border:'1px solid #E2E8F0',overflow:'hidden',marginBottom:16}}>
              <div style={{padding:'14px 20px',background:'#F8FAFC',borderBottom:'1px solid #E2E8F0',fontWeight:700,fontSize:14}}>📋 Αντιστοιχίες</div>
              {result.matches.map((m,i) => (
                <div key={i} style={{padding:'16px 20px',borderBottom:i<result.matches.length-1?'1px solid #F1F5F9':'none',background:m.risk_level==='HIGH'?'#FFFBFB':'#FFF'}}>
                  <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4}}>
                    <span style={{fontWeight:700,fontSize:14}}>{m.matched_entity}</span>
                    <Badge level={m.risk_level} small />
                    <span style={{fontSize:11,color:'#94A3B8'}}>{Math.round(m.similarity_score*100)}%</span>
                  </div>
                  <p style={{fontSize:13,color:'#475569',margin:'4px 0'}}>{m.explanation}</p>
                  {m.case_title && <p style={{fontSize:12,color:'#64748B'}}>📁 {m.case_title}</p>}
                  <p style={{fontSize:12,fontWeight:600,color:m.risk_level==='HIGH'?'#991B1B':'#065F46',margin:'6px 0 0',padding:'4px 10px',borderRadius:8,background:m.risk_level==='HIGH'?'#FEF2F2':'#F0FDF4',display:'inline-block'}}>💡 {m.recommendation}</p>
                </div>
              ))}
            </div>
          )}

          {result.ai_summary && (
            <div style={{background:'#FFF',borderRadius:16,border:'1px solid #E2E8F0',overflow:'hidden'}}>
              <div style={{padding:'14px 20px',background:'linear-gradient(135deg,#EEF2FF,#F0F9FF)',borderBottom:'1px solid #E2E8F0',fontWeight:700,fontSize:14}}>🤖 AI Νομική Ανάλυση</div>
              <div style={{padding:20}}><p style={{fontSize:14,color:'#374151',lineHeight:1.7,whiteSpace:'pre-wrap',margin:0}}>{result.ai_summary}</p></div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ConflictCheck;